import MarginsOverlay from '@/components/app/document/overlays/margins-overlay'
import { computeHalfTrimWidth } from '../helpers/page-trim-width'

type SinglePageMarginGuidesAboveShapesProps = {
  bleedMargin: number
  /** Full spread trim width (both pages). */
  trimWidth: number
  trimHeight: number
  marginInside: number
  marginOutside: number
  marginTop: number
  marginBottom: number
  /** `single-first` → right-hand page; `single-last` → left-hand page. */
  pageViewMode: 'single-first' | 'single-last'
  lineZIndex: number
  scale: number
}

/**
 * Pink margin guides for first/last single-page view — same stacking role as
 * {@link DoubleSpreadMarginGuidesAboveShapes} on a spread.
 */
export function SinglePageMarginGuidesAboveShapes({
  bleedMargin,
  trimWidth,
  trimHeight,
  marginInside,
  marginOutside,
  marginTop,
  marginBottom,
  pageViewMode,
  lineZIndex,
  scale,
}: SinglePageMarginGuidesAboveShapesProps) {
  const pageTrimWidth = computeHalfTrimWidth(trimWidth)

  if (pageTrimWidth <= 0) {
    return null
  }

  const trimLeft = pageViewMode === 'single-last' ? bleedMargin : bleedMargin + pageTrimWidth

  return (
    <MarginsOverlay
      trimLeft={trimLeft}
      trimTop={bleedMargin}
      trimWidth={pageTrimWidth}
      trimHeight={trimHeight}
      inside={marginInside}
      outside={marginOutside}
      top={marginTop}
      bottom={marginBottom}
      insideOnLeft={pageViewMode === 'single-first'}
      lineZIndex={lineZIndex}
      scale={scale}
    />
  )
}
